import {
  ExpenseDraftItem,
  type ExpenseDraftItemConstructor,
} from './ExpenseDraftItem'
import {
  type ExpenseStatusEnum,
  ExpenseStatuses,
} from '../enums/ExpenseStatusEnum'

export type {
  ExpenseDraftItemConstructor,
  ExpenseDraftItemAccount,
  ExpenseDraftItemCreditCard,
} from './ExpenseDraftItem'
export { ExpenseDraftItem } from './ExpenseDraftItem'

export interface ExpenseDraftConstructor {
  id: number
  uuid: string
  title: string
  status: ExpenseStatusEnum
  departmentId: number
  locationId: number
  nextApproverId: Nullable<number>
  travel: Nullable<number>
  notes: string
  createdDate: string
  items: ExpenseDraftItemConstructor[]
}

export class ExpenseDraft {
  readonly id: number
  readonly uuid: string
  readonly title: string
  readonly status: ExpenseStatusEnum
  readonly departmentId: number
  readonly locationId: number
  readonly nextApproverId: Nullable<number>
  readonly travel: Nullable<number>
  readonly notes: string
  readonly createdDate: string
  readonly items: ExpenseDraftItem[]

  constructor(data: ExpenseDraftConstructor) {
    this.id = data.id
    this.uuid = data.uuid
    this.title = data.title || ''
    this.status = data.status
    this.departmentId = data.departmentId
    this.locationId = data.locationId
    this.nextApproverId = data.nextApproverId ?? null
    this.travel = data.travel ?? null
    this.notes = data.notes ?? ''
    this.createdDate = data.createdDate ?? ''
    this.items = (data.items || []).map((item) => new ExpenseDraftItem(item))
  }

  get isDraft(): boolean {
    return this.status === ExpenseStatuses.DRAFT
  }

  get hasItems(): boolean {
    return this.items.length > 0
  }
}
